import dayjs from 'dayjs'

export const mapReceivement = (receivement) => {
  if (!receivement) {
    return null
  }

  return {
    id: receivement.id_recebimento,
    listNumberArId: receivement.ar_ids,
    startedAt: receivement.dt_inicio_recebimento
      ? dayjs(receivement.dt_inicio_recebimento)
      : null,
    status: receivement.status,
    vendorName: receivement.fornecedor.nm_fornecedor,
    fulfillmentCenter: {
      id: receivement?.fulfillment_center?.id ?? null,
      name: receivement?.fulfillment_center?.name ?? 'Recebimento sem FC'
    },
    id_user_release: receivement.id_user_liberacao,
  }
}
